import { loadFiles, log } from '../../loader-base/src/helpers';

const presets = {
    'preset-asterix-ng-5.0.4': [
        'https://ajax.googleapis.com/ajax/libs/angularjs/1.5.11/angular.min.js',
        'https://mwc-cdn.morningstar.com/mc/asterix-core/5.1.0/build/asterix-core.js',
        'https://mwc-cdn.morningstar.com/mc/asterix-ng/5.0.4/build/asterix-ng.js',
    ],
};

/**
 * Load the specified extra libraries
 * @param {*} config - the config options for the libraries to load
 */
function loadLibraries(config) {
    const fileUrls = [];
    if (!Array.isArray(config)) {
        log.warn('Libraries config section must be an array');
    } else {
        config.forEach((library) => {
            if (typeof library !== 'string') {
                log.warn('A library must be a string containing a URL or a preset name');
            } else if (library.indexOf('http') === 0 || library.indexOf('//') === 0) {
                fileUrls.push(library);
            } else if (library.indexOf('preset-') === 0 && !presets[library]) {
                log.warn(`Library preset ${library} does not exist`);
            } else if (library.indexOf('preset-') === 0) {
                presets[library].forEach(url => fileUrls.push(url));
            } else {
                log.warn(`Malformed library name: ${library}`);
            }
        });
    }
    return loadFiles(fileUrls);
}

export default loadLibraries;



// WEBPACK FOOTER //
// ./src/load-libraries.js